import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorCache,
  fetchProcessorCacheAttributes,
  fetchProcessorCacheById,
  updateProcessorCache,
  updateStatusInProcessorCache,
} from "./thunk";

interface CategoryState {
  processor_cors_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_cors_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_cache",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorCacheAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorCacheAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_cors_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorCacheAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchProcessorCacheById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorCacheById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorCacheById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorCache.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_cors_list = state.processor_cors_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(addProcessorCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorCache.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_cors_list = state.processor_cors_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(updateProcessorCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorCache.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorCache.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
